import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Form } from "antd";
const FormHeadline = (param)=>{
    let { children, description, headlineExtra, extra, offset } = param;
    return /*#__PURE__*/ _jsxs(Form.Item, {
        wrapperCol: {
            offset
        },
        style: {
            borderBottom: "1px solid #e7e7e7"
        },
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                justify: "space-between",
                align: "top",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        style: {
                            margin: `0 0 ${description ? 3 : 15}px 0`
                        },
                        children: children
                    }),
                    headlineExtra
                ]
            }),
            !!description && /*#__PURE__*/ _jsx("p", {
                className: "description",
                style: {
                    marginBottom: 15
                },
                children: description
            }),
            extra
        ]
    });
};
export { FormHeadline };
